// HyperGo — interactivity

(function () {
  // Force light theme — dark mode removed for accessibility/contrast consistency.
  document.documentElement.setAttribute('data-theme', 'light');

  // ---------- Footer year ----------
  const y = document.getElementById('year');
  if (y) y.textContent = new Date().getFullYear();

  // ---------- Reveal on scroll ----------
  // Use IntersectionObserver with a generous rootMargin so anything near the
  // viewport reveals; also fall back to a max-show timer so nothing stays hidden.
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px 200px 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
  // Safety: make sure all reveals show within 4s even if observer never fires
  setTimeout(() => reveals.forEach((el) => el.classList.add('is-visible')), 4000);
})();
